import { useEffect } from 'react';
import useAccessCodeApi from '../api/use-access-code-api';
import FormFooter from '../components/form-footer';
import Header from '../components/header';
import HipaaBanner from '../components/hipaa-banner';
import Link from '../components/link';
import SiteFooter from '../components/site-footer';
import { useFlexAssessmentContext } from '../context/context';
import styles from '../css/page.module.scss';
import { ReactComponent as IconArrow } from '../media/icon-right-arrow-cta.svg';
import ImageStartPage from '../media/landing-page-hug.webp';
import { FlexAssessmentContextAction } from '../types/flex-assessment-context-action';
import { NotificationType } from '../types/notification-type';
import { PAGE_URLS } from '../utils/constants';
import { STRINGS } from '../utils/strings';
import { useScrollToTop } from '../utils/use-scroll-to-top';

export default function AssessmentStartPage(): JSX.Element {
  useScrollToTop();
  const { state, dispatch } = useFlexAssessmentContext();
  const { checkIsAccessCodeAllowed } = useAccessCodeApi();
  const isAccessCodeAllowed = checkIsAccessCodeAllowed(state.accessCodeConfig);
  const isDisabled =
    !state.assessmentId || !state.userSelections || !isAccessCodeAllowed;

  useEffect(() => {
    if (!isAccessCodeAllowed) {
      dispatch({
        type: FlexAssessmentContextAction.showNotification,
        payload: {
          type: NotificationType.Error,
          isShowing: true,
          message: `${STRINGS.ERRORS.ACCESS_CODE_NOT_AVAILABLE}. Error: ${STRINGS.ERRORS.ACCESS_CODE_ERROR}`,
        },
      });
    }
  }, [dispatch, isDisabled]);

  return (
    <>
      <Header />
      <section className={styles.page}>
        <h1 className={styles.pageTitle}>Assess Your Resilience</h1>
        <h2 className={styles.subTitle}>
          Stress is part of life, but understanding how it impacts you is an
          important part of managing it. The Flex Assessment is a short survey
          that will help assess your flexibility to stress and provide a
          benchmark to work from. It only takes a few minutes to complete!
        </h2>
        <div className={styles.imgB2BStartPage}>
          <img src={ImageStartPage} height="240" alt="" />
        </div>
        <Link
          disabled={isDisabled}
          to={PAGE_URLS.QUESTIONS}
          type="yellow"
          className={styles.cta}
          dataTestId="startAssessmentCta"
        >
          Get My Flex Score
        </Link>
      </section>
      <HipaaBanner />
      <SiteFooter />
      <FormFooter classNames={styles.formFooter}>
        <Link
          disabled={isDisabled}
          to={PAGE_URLS.QUESTIONS}
          type="yellow"
          className={styles.mobileCta}
        >
          Start the Brief Assessment <IconArrow />
        </Link>
      </FormFooter>
    </>
  );
}
